import {put, takeLatest} from 'redux-saga/effects';
import talonActions from '../actions/talon.actions';
import {handleSagaError} from './utils/CommonUtils';

function* start() {
    try {
        yield put(talonActions.startSuccess());
    } catch (e) {
        yield handleSagaError(e, talonActions.startFailed(e));
    }
}

function* updateSolveToken(action) {
    try {
        yield put(talonActions.updateSolveTokenSuccess(action.payload));
    } catch (e) {
        yield handleSagaError(e, talonActions.updateSolveTokenFailed(e));
    }
}

function* reset() {
    try {
        yield put(talonActions.resetSuccess());
    } catch (e) {
        yield handleSagaError(e, talonActions.resetFailed(e));
    }
}

function* talonSagas() {
    yield takeLatest(talonActions.TYPES.START_TALON, start);
    yield takeLatest(talonActions.TYPES.UPDATE_SOLVE_TOKEN, updateSolveToken);
    yield takeLatest(talonActions.TYPES.RESET_TALON, reset);
}

export default talonSagas;
